<template><svg viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg"><path d="M12 7L0 13.928V.072L12 7z"/></svg></template>